import { closeSearchAtom } from "@/atoms/search"
import { CategoryImageCard } from "@/components/home/CategoryImageCard"
import { useBrowsingChannelCatalog } from "@/hooks/use-browsing-channel-catalog"
import { Category } from "@/types"
import { useSetAtom } from "jotai"
import { useNavigate } from "react-router-dom"

export function CategoryImages({ category, setItemsFilter }: {
  category: Category
  setItemsFilter: (value: string) => void
}) {
  const closeSearch = useSetAtom(closeSearchAtom)
  const navigate = useNavigate()
  const { categoriesItemOffers } = useBrowsingChannelCatalog()

  return (
    <CategoryImageCard
      category={category}
      categoryItemOffers={categoriesItemOffers[category.id] ?? []}
      onClick={() => {
        closeSearch()
        setItemsFilter("")
        navigate(`?category=${category.id}`)
      }}
    />
  )
}
